
const initialState = {
  loading: false,
  newPass: false,
  error: false,
  soldAdsListing: [],
  soldAdsDetail: null,
  totalSoldAds: 0,

};

const soldAdsReducer = (state = initialState, action) => {
  // console.log("bank  reducers------", state,action);
  switch (action.type) {
    case "ADD_SOLD_ADS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_SOLD_ADS_SUCCESS":
      return {
        ...state,
        loading: false,
        newPass: true,
        error: false,
      };
    case "ADD_SOLD_ADS_FAILED":
      return {
        ...state,
        loading: false,
        newPass: false,
        error: true,
      };

    case "GET_SOLD_ADS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_SOLD_ADS_REQUEST_FAILED":
      return {
        ...state,
        error: true,
      };
    case "GET_SOLD_ADS_REQUEST_SUCCESS":
      return {
        ...state,
        soldAdsListing: action.payload,
        loading: false,
        totalSoldAds: action.total,

      };

    case "GOT_SOLD_ADS_DETAIL":
      return {
        ...state,
        soldAdsDetail: action.payload,
      };
    default:
      return state;
  }
};

export default soldAdsReducer;
